export default __webpack_public_path__ + "static/media/080_finish_bad.hevc.8f008b70.mp4";